module.exports = __webpack_public_path__ + "img/div2.1b1e65ce.jpg";